// import api from 'api';
import { toast } from 'react-toastify';
import {
	ARCHIVE_MEMBER_INFO_FAIL,
	ARCHIVE_MEMBER_INFO_SUCCESS,
	GET_GROUP_INFO_FAIL,
	GET_GROUP_INFO_REQ,
	GET_GROUP_INFO_SUCCESS,
	GET_MEMBER_INFO_FAIL,
	GET_MEMBER_INFO_REQ,
	GET_MEMBER_INFO_SUCCESS,
} from '../constants/groupInfo';

import api from '../../services/api';

export const getGroupInfo =
	(page, groupFilter) => async (dispatch, getState) => {
		try {
			dispatch({ type: GET_GROUP_INFO_REQ });
			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};

			let url = '';

			if (page || groupFilter) {
				url = `/api/leads?page=${page}&gid=${groupFilter}`;
			} else {
				url = '/api/leads';
			}

			const { data } = await api.get(url, config);

			dispatch({
				type: GET_GROUP_INFO_SUCCESS,
				payload: data?.body,
			});
		} catch (error) {
			dispatch({
				type: GET_GROUP_INFO_FAIL,
				payload:
					error.response && error.response.data.error
						? error.response.data.error
						: error.message,
			});

			const message =
				error.response && error.response.data.error
					? error.response.data.error
					: error.message;
			if (message === 'NotAuthorized') {
				toast.error('Please login from extension and the reload this page');
				localStorage.removeItem('_gm_usr');
				window.location.reload();
			} else if(error.response.status === 401){
				toast.error("Autorization failed, please re-login to the extension")
			}
			 else {
				toast.error(message);
			}
		}
	};

export const getLeadInfo = (leadId) => async (dispatch, getState) => {
	try {
		dispatch({ type: GET_MEMBER_INFO_REQ });
		const {
			userLogin: { userInfo },
		} = getState();

		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.gmBackendToken}`,
			},
		};

		const { data } = await api.get(`/api/leads/${leadId}`, config);

		dispatch({
			type: GET_MEMBER_INFO_SUCCESS,
			payload: data?.body,
		});
	} catch (error) {
		dispatch({
			type: GET_MEMBER_INFO_FAIL,
			payload:
				error.response && error.response.data.error
					? error.response.data.error
					: error.message,
		});

		const message =
			error.response && error.response.data.error
				? error.response.data.error
				: error.message;
		if (message === 'NotAuthorized') {
			toast.error('Please login from extension and the reload this page');
			localStorage.removeItem('_gm_usr');
			window.location.reload();
		} else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
			toast.error(message);
		}
	}
};

export const archiveLeadDetails = (leadId) => async (dispatch, getState) => {
	try {
		const {
			userLogin: { userInfo },
		} = getState();

		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.gmBackendToken}`,
			},
		};

		const { data } = await api.delete(`/api/leads/${leadId}`, config);

		dispatch({
			type: ARCHIVE_MEMBER_INFO_SUCCESS,
			payload: data?.body?.updatedId,
		});

		toast.success(data?.body?.message);
	} catch (error) {
		dispatch({
			type: ARCHIVE_MEMBER_INFO_FAIL,
			payload:
				error.response && error.response.data.error
					? error.response.data.error
					: error.message,
		});

		const message =
			error.response && error.response.data.error
				? error.response.data.error
				: error.message;
		if (message === 'NotAuthorized') {
			toast.error('Please login from extension and the reload this page');
			localStorage.removeItem('_gm_usr');
			window.location.reload();
		} else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
			toast.error(message);
		}
	}
};
